"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultModal = void 0;
exports.validateSiteNumberInput = validateSiteNumberInput;
var React = require("react");
var moment = require("moment");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var CopyUserProfilePermissionMenuItems_1 = require("../CopyUserProfilePermissionMenuItems");
var DatePicker_1 = require("components/DatePicker");
var fields_1 = require("../fields");
var classes = {
    NONE: '',
    CATEGORY: 'project-members-modal-create-category',
    SOKOBID: 'project-members-modal-create-briefcase',
    USER_PROFILE: 'project-members-modal-create-user-profile',
    TRMETER: 'project-members-modal-create-trmeter',
    MVRMETER: 'project-members-modal-create-trmeter',
    WORKSITE_DIARY: 'project-members-modal-create-worksitediary',
    LIGHT_ADMIN: 'project-members-modal-create-light-admin-group'
};
var failMessage = {
    NONE: '',
    CATEGORY: 'userfront/project/teamMembers/categoryCreationFailed',
    SOKOBID: 'userfront/project/teamMembers/briefcaseCreationFailed',
    USER_PROFILE: 'userfront/project/teamMembers/userProfileCreationFailed',
    TRMETER: 'userfront/project/teamMembers/trmeterCreationFailed',
    MVRMETER: 'userfront/project/teamMembers/trmeterCreationFailed',
    WORKSITE_DIARY: 'userfront/project/teamMembers/worksitediaryCreationFailed',
    LIGHT_ADMIN: 'userfront/project/teamMembers/lightAdminGroupCreationFailed'
};
var headerName = {
    NONE: '',
    CATEGORY: 'userfront/project/teamMembers/createNewCategory',
    SOKOBID: 'userfront/project/teamMembers/createNewBriefcase',
    USER_PROFILE: 'userfront/project/teamMembers/createNewUserProfile',
    TRMETER: 'userfront/project/teamMembers/createNewTRMeter',
    MVRMETER: 'userfront/project/teamMembers/createNewMVRMeter',
    WORKSITE_DIARY: 'userfront/project/teamMembers/createNewWorksiteDiary',
    LIGHT_ADMIN: 'userfront/project/teamMembers/createNewLightAdminGroup'
};
var groupName = {
    NONE: '',
    CATEGORY: 'userfront/project/teamMembers/categoryName',
    SOKOBID: 'userfront/project/teamMembers/briefcaseName',
    USER_PROFILE: 'userfront/project/teamMembers/userProfileName',
    TRMETER: 'userfront/project/teamMembers/worksitediaryName',
    MVRMETER: 'userfront/project/teamMembers/worksitediaryName',
    WORKSITE_DIARY: 'userfront/project/teamMembers/worksitediaryName',
    LIGHT_ADMIN: 'userfront/project/teamMembers/lightAdministratorName'
};
// No translation link is added for TR/MVR meter and worksite diary as there is no
// usecase for it. No description is added for them.
var groupDescription = {
    NONE: '',
    CATEGORY: 'userfront/project/teamMembers/categoryDescription',
    SOKOBID: 'userfront/project/teamMembers/briefcaseDescription',
    USER_PROFILE: 'userfront/project/teamMembers/userProfileDescription',
    TRMETER: '',
    MVRMETER: '',
    WORKSITE_DIARY: '',
    LIGHT_ADMIN: 'userfront/project/teamMembers/userProfileDescription'
};
var copyPermGroupTypes = [
    'NormalUserGroup',
    'CategoryUserGroup',
    'CustomerCategoryUserGroup',
    'CustomerUserGroup'
];
var headerGroupTypes = [
    'CategoryUserGroup',
    'CustomerCategoryUserGroup'
];
var getErrorMessage = function (key, error) {
    if (error && error.type === 'CONFLICT') {
        if (key === 'TRMETER' || key === 'MVRMETER') {
            return 'userfront/project/teamMembers/trmeterCreationFailed/alreadyExists';
        }
        else if (key === 'WORKSITE_DIARY') {
            return 'userfront/project/teamMembers/worksitediaryCreationFailed/alreadyExists';
        }
    }
    return failMessage[key];
};
function validateSiteNumberInput(evt) {
    if (evt.key === 'Enter') {
        return;
    }
    var theEvent = evt || window.event;
    var key = theEvent.keyCode || theEvent.which;
    var charFromKey = String.fromCharCode(key);
    var regex = /[0-9]|\./;
    if (!regex.test(charFromKey)) {
        if (theEvent.preventDefault)
            theEvent.preventDefault();
        return false;
    }
}
var DefaultModal = function (props) { return (React.createElement(sok_ui_1.Modal, { isOpen: props.createEdit.status === 'CREATE', className: classes[props.createEdit.type] },
    React.createElement(sok_ui_1.Header, { onClose: props.toggleModal }, (0, translation_1.getLocalization)(headerName[props.createEdit.type])),
    React.createElement("form", { onSubmit: function (e) {
            e.preventDefault();
            if (props.createEdit.type === 'CATEGORY') {
                props.createCategory(props.currentProject, props.name.trim(), props.description.trim());
            }
            else if (props.createEdit.type === 'SOKOBID' ||
                props.createEdit.type === 'USER_PROFILE') {
                var validityPeriod = null;
                if (props.validSince !== null && props.validUntil !== null) {
                    validityPeriod = {
                        validSince: props.validSince,
                        validUntil: props.validUntil
                    };
                }
                props.selectedCategory &&
                    props.createProfile(props.currentProject, props.selectedCategory.id, props.name.trim(), props.description.trim(), props.copiedUserProfile !== undefined
                        ? props.copiedUserProfile.id
                        : undefined, validityPeriod ? validityPeriod : undefined);
            }
            else if (props.createEdit.type === 'TRMETER' ||
                props.createEdit.type === 'MVRMETER') {
                props.createTRMVRMeter(props.currentProject, props.name.trim(), props.siteNumber, props.createEdit.type === 'MVRMETER');
            }
            else if (props.createEdit.type === 'WORKSITE_DIARY') {
                props.createWorksiteDiary(props.currentProject, props.name.trim(), props.siteNumber);
            }
        } },
        React.createElement(sok_ui_1.Container, null,
            React.createElement("div", { className: 'content' },
                React.createElement(sok_ui_1.Row, null,
                    React.createElement(fields_1.GroupCategorySelection, { renderIf: ['USER_PROFILE', 'SOKOBID'].includes(props.createEdit.type), groups: props.groups, includeCategories: props.createEdit.type === 'SOKOBID'
                            ? ['SokoBidCategoryUserGroup']
                            : undefined, selectedCategory: props.selectedCategory, setSelectedCategory: props.setSelectedCategory }),
                    React.createElement(sok_ui_1.Column, null,
                        React.createElement("label", { htmlFor: 'groupname' }, (0, translation_1.getLocalization)(groupName[props.createEdit.type])),
                        React.createElement(sok_ui_1.TextInput, { id: 'groupname', value: props.name, disabled: props.createEdit.type === 'USER_PROFILE'
                                ? !props.selectedCategory
                                : false, placeholder: (0, translation_1.getLocalization)(groupName[props.createEdit.type]), onChange: function (e) {
                                return props.setName(e.target.value.toString());
                            }, autoFocus: true }),
                        (props.createEdit.type === 'CATEGORY' ||
                            props.createEdit.type === 'USER_PROFILE' ||
                            props.createEdit.type === 'SOKOBID') && (React.createElement(sok_ui_1.Column, null,
                            React.createElement("label", { htmlFor: 'groupdescription' }, (0, translation_1.getLocalization)(groupDescription[props.createEdit.type])),
                            React.createElement(sok_ui_1.TextInput, { id: 'groupdescription', value: props.description, disabled: props.createEdit.type === 'USER_PROFILE'
                                    ? !props.selectedCategory
                                    : false, placeholder: (0, translation_1.getLocalization)(groupDescription[props.createEdit.type]), onChange: function (e) {
                                    return props.setDescription(e.target.value.toString());
                                }, autoFocus: true })))),
                    props.createEdit.type === 'USER_PROFILE' && (React.createElement(React.Fragment, null,
                        React.createElement(sok_ui_1.Column, null,
                            React.createElement("label", { htmlFor: 'groupname' }, (0, translation_1.getLocalization)('userfront/project/teamMembers/userProfilePermissionsToCopy')),
                            React.createElement(sok_ui_1.Dropdown2, { alignment: 'left', className: 'drop-down-selection', disabled: !props.userProfiles || props.userProfiles.length === 0 },
                                React.createElement(sok_ui_1.TextInput, { id: 'grouptype', editable: false, className: 'white', value: props.copiedUserProfile
                                        ? props.copiedUserProfile.name
                                        : (0, translation_1.getLocalization)(!props.userProfiles ||
                                            props.userProfiles.length === 0
                                            ? 'userfront/project/teamMembers/noUserProfiles'
                                            : 'userfront/project/teamMembers/selectUserProfile'), iconRight: React.createElement(sok_ui_1.Icon, { className: 'fa-caret-down' }) }),
                                React.createElement(sok_ui_1.Dropdown2Menu, { key: 'categoryMenu', className: 'project-members-modal-create-user-profile-dropdown' },
                                    React.createElement(CopyUserProfilePermissionMenuItems_1.CopyUserProfilePermissionMenuItems, { groups: props.groups, includeCategoryTypes: copyPermGroupTypes, disableCategoryTypes: headerGroupTypes, setCopiedUserProfile: props.setCopiedUserProfile })))),
                        React.createElement(sok_ui_1.Column, null,
                            React.createElement("label", { htmlFor: 'date-picker' }, (0, translation_1.getLocalization)('userfront/project/teamMembers/userProfileValidityPeriod'))),
                        React.createElement(sok_ui_1.Column, { large: 6, medium: 6, extraSmall: 6, className: 'date-input' },
                            React.createElement(DatePicker_1.DatePicker, { placeholder: (0, translation_1.getLocalization)('datePicker/time'), showTimeSelect: true, selected: props.validSince && moment(props.validSince, 'L HH:mm'), onChange: function (m, e) {
                                    if (e) {
                                        e.stopPropagation();
                                        e.preventDefault();
                                    }
                                    props.setValidSince(m);
                                }, timeCaption: (0, translation_1.getLocalization)('datePicker/time'), selectsStart: true, maxDate: props.validUntil || undefined, dateFormat: "L HH:mm" })),
                        React.createElement(sok_ui_1.Column, { large: 6, medium: 6, extraSmall: 6, className: 'date-input' },
                            React.createElement(DatePicker_1.DatePicker, { placeholder: (0, translation_1.getLocalization)('userfront/project/teamMembers/userProfileValidUntil'), className: 'date-input', selected: props.validUntil && moment(props.validUntil, 'L HH:mm'), onChange: function (m, e) {
                                    if (e) {
                                        e.stopPropagation();
                                        e.preventDefault();
                                    }
                                    props.setValidUntil(m);
                                }, timeCaption: (0, translation_1.getLocalization)('userfront/orderwizard/step1/requestedTime'), selectsEnd: true, showTimeSelect: true, dateFormat: "L HH:mm" })))),
                    (props.createEdit.type === 'MVRMETER' ||
                        props.createEdit.type === 'TRMETER' ||
                        props.createEdit.type === 'WORKSITE_DIARY') && (React.createElement(sok_ui_1.Column, null,
                        React.createElement("label", { htmlFor: 'worksitediarynumber' }, (0, translation_1.getLocalization)('userfront/project/teamMembers/worksitediaryNumber')),
                        React.createElement(sok_ui_1.TextInput, { type: 'text', inputMode: 'text', min: "1", id: 'worksitediarynumber', value: props.siteNumber || '', placeholder: (0, translation_1.getLocalization)('userfront/project/teamMembers/worksitediaryNumber'), onKeyPress: validateSiteNumberInput, onChange: function (e) {
                                return props.setNumber(e.target.value);
                            } }))),
                    props.createEdit.isSaving === 'FAILED' && (React.createElement(sok_ui_1.Column, null,
                        React.createElement("span", { className: 'request-failed' }, (0, translation_1.getLocalization)(getErrorMessage(props.createEdit.type, props.createEdit.error)))))))),
        React.createElement(sok_ui_1.Footer, null,
            React.createElement(sok_ui_1.Button, { disabled: props.createEdit.isSaving === 'SAVING' ||
                    props.name.trim().length === 0 ||
                    props.createEdit.type === 'USER_PROFILE'
                    ? props.selectedCategory === null
                    : false, text: (0, translation_1.getLocalization)('userfront/project/teamMembers/save'), color: 'base-green', type: 'submit' }),
            React.createElement(sok_ui_1.Button, { text: (0, translation_1.getLocalization)('userfront/project/teamMembers/cancel'), color: 'dark-gray', onClick: props.toggleModal }))))); };
exports.DefaultModal = DefaultModal;
